import cx from 'classnames';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GovFlex } from '@gov-design-system-ce/react';
import { Button, Icon, LayoutGap, SectionHeader } from '@gov-nx/ui/web';
import { useCarouselScroll } from '@gov-nx/utils/web';

export interface CardCarouselProps {
	children: React.ReactNode;
	headline: string;
	headlineId: string;
	showAllButton?: string;
	showAllButtonUrl?: string;
	showAllButtonAria?: string;
	arrowLeftAria: string;
	arrowRightAria: string;
}

export const CardCarousel = ({
	children,
	headline,
	headlineId,
	showAllButton,
	showAllButtonUrl,
	showAllButtonAria,
	arrowLeftAria,
	arrowRightAria,
}: CardCarouselProps) => {
	const navigate = useNavigate();

	const { ref, onLeft, onRight, isOnLeftEdge, isOnRightEdge } =
		useCarouselScroll();
	return (
		<LayoutGap
			gap="l"
			className="justify-center">
			<SectionHeader
				id={headlineId}
				headline={headline}>
				<GovFlex
					gap="s"
					direction="row"
					responsive="false">
					{showAllButton && (
						<Button
							color="primary"
							size="s"
							type="base"
							onClick={() => showAllButtonUrl && navigate(showAllButtonUrl)}
							aria-label={showAllButtonAria}>
							{showAllButton}
						</Button>
					)}
					<GovFlex
						gap="s"
						direction="row"
						responsive="false">
						<Button
							color="primary"
							size="s"
							type="solid"
							isDisabled={isOnLeftEdge}
							onClick={onLeft}
							aria-label={arrowLeftAria}>
							<Icon
								name="chevron-left"
								type="components"
							/>
						</Button>
						<Button
							color="primary"
							size="s"
							type="solid"
							isDisabled={isOnRightEdge}
							onClick={onRight}
							aria-label={arrowRightAria}>
							<Icon
								name="chevron-right"
								type="components"
							/>
						</Button>
					</GovFlex>
				</GovFlex>
			</SectionHeader>
			<div
				className={cx(
					'gov-carousel',
					isOnRightEdge && 'gov-carousel__no-right-shadow',
					(isOnLeftEdge || !isOnRightEdge) &&
						'gov-carousel__left-shadow gov-carousel__right-shadow',
					isOnLeftEdge && 'gov-carousel__no-left-shadow'
				)}>
				<ul
					ref={ref}
					className="gov-card-flex gov-list--plain flex gap-(--templates-margin-l) pl-0!">
					{children}
				</ul>
			</div>
		</LayoutGap>
	);
};
